import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=376c8742&scoped=true&"
import script from "./BaseFilter.vue?vue&type=script&lang=js&"
export * from "./BaseFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c8742",
  null
  
)

export default component.exports